import { Link } from 'react-router-dom';

const ENTRIES = [
  { label: '热门电影', desc: '院线佳作速览', icon: 'ri-movie-2-line', to: '/category/movie', tone: 'accent' },
  { label: '热播剧集', desc: '追剧不掉队', icon: 'ri-tv-2-line', to: '/category/tv', tone: 'primary' },
  { label: '最新资讯', desc: '影视动态先知', icon: 'ri-newspaper-line', to: '/news', tone: 'secondary' },
  { label: '影评攻略', desc: '深度解读合集', icon: 'ri-quill-pen-line', to: '/special', tone: 'accent' },
  { label: '科幻专区', desc: '星际与未来', icon: 'ri-planet-line', to: '/search?q=科幻', tone: 'secondary' },
  { label: '悬疑犯罪', desc: '烧脑推理片单', icon: 'ri-focus-3-line', to: '/search?q=悬疑', tone: 'primary' },
  { label: '爱情治愈', desc: '温柔的力量', icon: 'ri-heart-3-line', to: '/search?q=爱情', tone: 'accent' },
  { label: '古装历史', desc: '穿越千年时光', icon: 'ri-ancient-gate-line', to: '/search?q=古装', tone: 'secondary' },
];

const TONES: Record<string, string> = {
  accent: 'bg-accent-500/15 text-accent-400 border-accent-500/30',
  primary: 'bg-primary-500/25 text-primary-200 border-primary-400/40',
  secondary: 'bg-secondary-500/15 text-secondary-300 border-secondary-500/30',
};

export default function CategoryQuick() {
  return (
    <section className="w-full px-4 md:px-8 -mt-10 relative z-20">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-8 gap-3 md:gap-4">
        {ENTRIES.map((entry) => (
          <Link
            key={entry.label}
            to={entry.to}
            className="group flex flex-col items-center text-center gap-2 p-4 rounded-lg bg-background-100 border border-background-200/70 hover:border-accent-500/50 transition-colors"
          >
            <span
              className={`w-11 h-11 flex items-center justify-center rounded-lg border ${TONES[entry.tone]} group-hover:scale-105 transition-transform`}
            >
              <i className={`${entry.icon} text-xl`}></i>
            </span>
            <span className="text-sm font-medium text-foreground-900 group-hover:text-accent-400 transition-colors whitespace-nowrap">
              {entry.label}
            </span>
            <span className="text-xs text-foreground-500">{entry.desc}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}